export default __webpack_public_path__ + "static/media/330_dummy2016-delikatessen01-mobile.c0aa26b8.png";